// Download block for case studies (file {u, h, x, size, icon}): a card with the file type icon, name, description, size and a download button.
// window.FileInfo.iconFor(u) -> Material Symbols name for the file's extension; .label(u) -> "PDF"; .nameOf(u) -> original file name; .sizeText(bytes)
// Uploaded files are served as attachments (server.js), whatever their type. Props: b (the block)
(function () {
  const { Box, Typography } = MaterialUI;

  const TYPES = [
    ['picture_as_pdf', 'PDF', 'pdf'],
    ['description', 'Document', 'doc docx odt rtf pages'],
    ['article', 'Text', 'txt md log'],
    ['table_chart', 'Spreadsheet', 'xls xlsx xlsm ods csv tsv numbers'],
    ['slideshow', 'Presentation', 'ppt pptx odp key'],
    ['folder_zip', 'Archive', 'zip rar 7z tar gz tgz bz2 xz'],
    ['image', 'Image', 'png jpg jpeg gif webp avif bmp heic tif tiff ico'],
    ['palette', 'Design file', 'ai psd psb sketch fig xd eps indd afdesign afphoto'],
    ['audio_file', 'Audio', 'mp3 wav flac ogg m4a aac aiff mid midi'],
    ['video_file', 'Video', 'mp4 mov webm mkv avi m4v'],
    ['code', 'Code', 'js mjs ts jsx tsx py rb php java c cpp h cs go rs swift kt sh css scss json xml yml yaml sql'],
    ['font_download', 'Font', 'ttf otf woff woff2'],
    ['menu_book', 'E-book', 'epub mobi azw3'],
    ['deployed_code', '3D model', 'obj fbx stl gltf glb blend 3mf'],
    ['apps', 'Application', 'exe msi dmg apk pkg deb appimage ipa']
  ];
  const BY_EXT = {};
  TYPES.forEach(([icon, label, exts]) => exts.split(' ').forEach(e => { BY_EXT[e] = { icon, label }; }));

  const extOf = u => ((String(u || '').split('?')[0].match(/\.([A-Za-z0-9]+)$/) || [])[1] || '').toLowerCase();
  const typeOf = u => BY_EXT[extOf(u)] || { icon: 'draft', label: extOf(u).toUpperCase() || 'File' };
  // Stored names are "<time>-<hex>-<original>"
  const nameOf = u => { try { return decodeURIComponent(String(u || '').split('/').pop().replace(/^\d+-[0-9a-f]{8}-/, '')); } catch (e) { return ''; } };
  const sizeText = n => (!n ? '' : n < 1024 ? `${n} B` : n < 1048576 ? `${Math.round(n / 1024)} KB` : `${(n / 1048576).toFixed(n < 10485760 ? 1 : 0)} MB`);

  window.FileInfo = { iconFor: u => typeOf(u).icon, label: u => typeOf(u).label, nameOf, sizeText };

  function FileBlock({ b }) {
    const { SurfaceCard, IconTile, Button, GoogleIcon } = window.Components;
    if (!b.u) return null;
    const name = nameOf(b.u);
    const meta = [typeOf(b.u).label, sizeText(b.size)].filter(Boolean).join(' · ');
    return (
      <SurfaceCard sx={{ my: 2, p: { xs: 2, md: 2.5 }, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
        <IconTile icon={b.icon || typeOf(b.u).icon} tone="primary" size="lg" shape="large" />
        <Box sx={{ flex: '1 1 220px', minWidth: 0 }}>
          <Typography variant="subtitle1" component="h4" sx={{ m: 0, overflowWrap: 'anywhere' }}>{b.h || name}</Typography>
          {b.x && <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, whiteSpace: 'pre-line' }}>{b.x}</Typography>}
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>{meta}</Typography>
        </Box>
        <Button variant="tonal" href={b.u} download={name} icon={<GoogleIcon name="download" size={18} />} aria-label={`Download ${b.h || name}`}>Download</Button>
      </SurfaceCard>
    );
  }

  window.Components = window.Components || {};
  window.Components.FileBlock = FileBlock;
})();
